import { jsx, jsxs } from "react/jsx-runtime";
import { memo } from "react";
import {
  Line,
  Path,
  Svg
} from "react-native-svg";
import { themed } from "../themed";
const Icon = (props) => {
  const { color = "black", size = 24, ...otherProps } = props;
  return /* @__PURE__ */ jsxs(
    Svg,
    {
      width: size,
      height: size,
      viewBox: "0 0 24 24",
      fill: "none",
      stroke: `${color}`,
      strokeWidth: "2",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      ...otherProps,
      children: [
        /* @__PURE__ */ jsx(Path, { d: "M3 6h18", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M19 6v14c0 1-1 2-2 2H7c-1 0-2-1-2-2V6", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Path, { d: "M8 6V4c0-1 1-2 2-2h4c1 0 2 1 2 2v2", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "10", x2: "10", y1: "11", y2: "17", stroke: `${color}` }),
        /* @__PURE__ */ jsx(Line, { x1: "14", x2: "14", y1: "11", y2: "17", stroke: `${color}` })
      ]
    }
  );
};
Icon.displayName = "Trash2";
const Trash2 = memo(themed(Icon));
export {
  Trash2
};
//# sourceMappingURL=trash-2.js.map
